import { IModalState } from 'entities/Modal/Modal.models';
import { EModalKey } from 'entities/Modal/Modal.enum';

export const modalReducers = {
  showModal: (state: IModalState, payload: EModalKey) => ({ ...state, [payload]: { open: true } }),
  hideModal: (state: IModalState, payload: EModalKey) => ({ ...state, [payload]: { open: false } }),
};
